import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=2128b925&scoped=true&"
import script from "@/views/Users/Student/InformationDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/InformationDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/information-dialog.scss?vue&type=style&index=0&id=2128b925&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128b925",
  null
  
)

export default component.exports